import { IPostcodeChildTicketVerifyState } from '../../reducers/postcode-child-ticket-verify';
import { createSelector } from '@ngrx/store';
import { getCheckoutFeatureState, ICheckoutFeatureState } from '../../reducers';
import { selectChildTicketIds } from '../basket';
import {
  allChildTicketsVerified,
  childTicketVerifyInProgress,
  invalidChildTicketsExist,
} from '@modules/checkout-store/util/postcode-child-ticket-verify';

export const selectPostcodeChildTicketVerifyState = createSelector(
  getCheckoutFeatureState,
  (state: ICheckoutFeatureState) => state?.postcodeChildTicketVerify
);

export const selectHasInvalidPostcodeForChildTickets = createSelector(
  selectPostcodeChildTicketVerifyState,
  (state: IPostcodeChildTicketVerifyState): boolean =>
    invalidChildTicketsExist(state)
);

export const selectAllChildTicketsVerified = createSelector(
  selectPostcodeChildTicketVerifyState,
  selectChildTicketIds,
  (
    state: IPostcodeChildTicketVerifyState,
    childTicketIds: number[]
  ): boolean | undefined => allChildTicketsVerified(state, childTicketIds)
);

export const selectVerifyInProgress = createSelector(
  selectPostcodeChildTicketVerifyState,
  (state: IPostcodeChildTicketVerifyState): boolean =>
    childTicketVerifyInProgress(state)
);
